<template>
  <div class="index">
    <div class="index_body fade_in" @click="toAnswer">
      点击进入
    </div>
    <div class="index_title">
      安蓝航运智能助手
    </div>
    <div class="index_footer">
      <div class="index_footer_one">
          官方网站
          www.anlantech.cn
      </div>
      <div class="index_footer_one">
          客服邮箱
          ship@anlantech.cn
      </div>
    </div>
  </div>
</template>

<script>
  import { querywxlogin,getUserPrivileges } from "../../api/api";
  import { getJsonStorage,setJsonStorage } from "../../util/storage";
  import { getBrowserType } from "../../util/common"

  export default {
    name: "IndexIndex",
    data() {
      return {
        user:getJsonStorage('openai_user'),
        privileges:getJsonStorage('openai_privileges')
      }
    },
    mounted(){
      if(getBrowserType()===1){
        let ll = location.href.split("?");
        if(ll.length>1){
          querywxlogin(ll[1]);
        }
      }
    },
    methods: {
      toAnswer(){
        if(this.user){
          getUserPrivileges().then(res => {
            if(res && res.status === 0){
              setJsonStorage('openai_privileges',res.data);
              this.$router.push('/index/answer');
            }
          });
        }else{
          if(getBrowserType()===1){
            this.$wx.miniProgram.redirectTo({url: '/pages/login/login'})
          }else{
            this.$router.push("/index/login");
          }
        }
      }
    }
  }
</script>

<style scoped>
  .index {
    position:absolute;
    top:0;
    left:0;
    width: 100%;
    height: 100vh;
    background: url("/static/imgs/mainBg.jpg") no-repeat top center;
    background-size:cover;
  }

  .index_body {
    position:absolute;
    width:100%;
    top:20vh;
    height:25vh;
    line-height:38vh;
    text-align:center;
    color:white;
    font-weight:bold;
    font-size:1.2rem;
    letter-spacing: .3rem;
    text-shadow: 2px 2px 1px #0066c8;
    cursor:pointer;
  }

  .fade_in {
    opacity: .1;
    animation: indexFadeIn 3s infinite forwards;
  }

  @keyframes indexFadeIn {
    0% {
      opacity: .1;
    }
    30% {
      opacity: 1;
    }
    70% {
      opacity: 1;
    }
    100% {
      opacity: .1;
    }
  }

  .index_footer {
    position: absolute;
    width:100%;
    text-align: center;
    color: white;
    bottom:8vh;
  }

  .index_footer_one {
    height:1.5rem;
    text-align:center;
    font-size: .9rem;
    color:#efefef;
  }

  .index_title {
    position:absolute;
    top:54vh;
    left:0;
    width:100%;
    height:2rem;
    line-height:2rem;
    font-size:1.25rem;
    color:white;
    text-align:center;
    letter-spacing:.2rem;
    text-shadow: -2px -2px 2px #0066c8;
  }
</style>



// WEBPACK FOOTER //
// src/components/index/index.vue